import {TYPES} from '../Actions/policyAction';
import * as moment from 'moment';

const policyReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_ALL_POLICIES_SUCCESS:
            return {
                ...state,
                allPolicies: action.allPolicies
            };
        case TYPES.FETCH_POLICY_COUNT_SUCCESS:
            return {
                ...state,
                policyCount: {
                    value: action.policyCount,
                    updatedAt: moment()
                }
            };
        case TYPES.IN_APPLY_POLICY_SUCCESS:
        case TYPES.IN_INSURE_POLICY_SUCCESS:
        case TYPES.UPDATE_POLICY_SUCCESS:
            return {
                ...state,
                pySummary: action.pySummary
            };
        default:
            return state;
    }
};

export default policyReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/policyReducer.ts